import React, { Component } from 'react';
import { matchPath } from 'react-router';
import Helmet from 'react-helmet';
import './ReviewsList.css';

import AuthService from './AuthService';
import UserNavbar from './UserNavbar';
import SelfSideBar from './SelfSideBar';
import NavBar from './Navbar';
import Reviews from './Reviews';
import constants from '../config';
import AuthModalContext from '../contexts/AuthModalContext';

const Auth = new AuthService();



class ReviewsList extends Component {
  static contextType = AuthModalContext;
  constructor() {
    super();
    this.state = {
      reviews: [],
      seller: {
        name: '',
        rating: 0,
      },
    };
    // GUEST NAVBAR
    this.toLogin = this.toLogin.bind(this);
    this.toSignUp = this.toSignUp.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    // USER NAVBAR
    this.handlePost = this.handlePost.bind(this);
    this.handleHome = this.handleHome.bind(this);
    this.handleSelfProfile = this.handleSelfProfile.bind(this);
    this.handleNotifications = this.handleNotifications.bind(this);



    //PAGE FUNCTIONALITY
    this.reviews = this.reviews.bind(this);
  }
  componentWillMount() {
  }

  //Function that always run
  componentDidMount() {
    // this.reviews();
    console.log(this.props);
    const match = matchPath(this.props.history.location.pathname, {
      path: '/reviews/:user_id',
      exact: false,
      strict: false,
    });

    const userId = match.params.user_id;
    this.reviews(userId);
    console.log("id", userId);
  }

  // GUEST NAVBAR
  handleSearch(search) {
    this.setState({
      query: search,
    }, () => {
      this.props.history.push(`/search/${this.state.query}`);
    });
  }

  toLogin() {
    this.context.openAuthModal('login');
  }

  toSignUp() {
    this.context.openAuthModal('signup');
  }
  // NAVBAR ROUTES
  handlePost() {
    this.props.history.push('/sell');
  }
  handleHome() {
    this.props.history.push('/');
  }
  handleSelfProfile() {
    const user = Auth.getProfile();
    this.props.history.push(`/shop/${user.username}`);
  }
  handleNotifications() {
    this.props.history.push('/notifications');
  }

  // PAGE FUNCTIONALITY

  reviews(userId) {
    if (Auth.getToken()) { // if user
      Auth.fetch(`${constants.DOMAIN}/api/v1/guest/reviews/${userId}/list`, {
        mode: 'cors',
        method: 'GET',
      }).then(res => {
        console.log('response', res)
        this.setState({
          reviews: res.reviews,
          seller: res.seller,
          sideBar: <SelfSideBar user={res.seller} />,
          navbar: <UserNavbar user={Auth.getProfile()} handleSearch={(search) => this.handleSearch(search)} handleSelfProfile={this.handleSelfProfile} handlePost={this.handlePost} handleHome={this.handleHome} handleNotifications={this.handleNotifications}/>
        }, () => {
          this.setState({ sideBar: <SelfSideBar user={this.state.seller} />,})
          console.log("reviews", this.state.reviews);


        });
      })
        .catch(err => {
          console.log(err);
        })

    } else {//user is guest
      Auth.fetch(`${constants.DOMAIN}/api/v1/guest/reviews/${userId}/list`, {
        mode: 'cors',
        method: 'GET',
      }).then(res => {
        console.log('response', res)
        this.setState({
          seller: res.seller,
          reviews: res.reviews,
          sideBar: <SelfSideBar user={res.seller} />,
          navbar: <NavBar handleSearch={(search) => this.handleSearch(search)} signUp={this.toSignUp} login={this.toLogin} />
        }, () => {
          console.log(this.state.reviews);
        });
      })
        .catch(err => {
          console.log(err);
        })




    }

  }


  render() {
    const reviews = this.state.reviews.map(review =>
      (<Reviews
        picture={review.buyer.image || review.buyer.picture}
        name={review.buyer.name}
        userName={review.buyer.userName}
        rating={review.rating}
        review={review.review}
      />));


    var seller = this.state.seller || {};
    var sellerName = seller.name || '';
    var sellerRating = seller.rating || 0;

    return (
      <div className="Search">
        <Helmet>
          <title>{sellerName}'s Reviews | Primal Marketplace</title>
          <meta name="description" content={`${sellerName} has ${this.state.reviews.length} reviews with a rating of ${sellerRating.toFixed(1)}/5`} />
          <meta property="og:title"       content={`${sellerName}'s Reviews | Primal Marketplace`} />
          <meta property="og:description" content={`${sellerName} has ${this.state.reviews.length} reviews with a rating of ${sellerRating.toFixed(1)}/5`} />
          <meta property="og:image"       content={`${constants.DOMAIN}/${seller.picture || ''}`} />
        </Helmet>
        {this.state.navbar}
        <div style={{ position: 'relative' }} className="col-md-12 notifications-heading">
          <h3>Reviews</h3>
        </div>
        <div className="col-md-12 after-heading">
        </div>
        {this.state.sideBar}

        <div style={{ marginLeft: '0px', marginTop: '0px' }} className="col-md-5 col-xs-12 content">
          {reviews}
        </div>
      </div>
    );
  }
}

export default ReviewsList;
